//src/components/AnalysisResult.tsx
import React from 'react';

interface AnalysisResultProps {
  result: string;
}

const AnalysisResult: React.FC<AnalysisResultProps> = ({ result }) => {
  return (
    <div>
      <h2>Risultato Analisi</h2>
      <pre>{result}</pre>
    </div>
  );
};

export default AnalysisResult;
